import { SliceStateCreator } from './useBoundStore';

export interface EmojiPickerTarget {
  type: 'Note' | 'Response' | 'CheckIn' | 'Comment';
  id: number | null;
  top?: number;
}
interface EmojiPickerState {
  emojiPickerTarget: EmojiPickerTarget | null;
}

interface EmojiPickerAction {
  setEmojiPickerTarget: (target: EmojiPickerState['emojiPickerTarget']) => void;
}

const initialState: EmojiPickerState = {
  emojiPickerTarget: null,
};

export type EmojiPickerSlice = EmojiPickerState & EmojiPickerAction;

export const createEmojiPickerSlice: SliceStateCreator<EmojiPickerSlice> = (set) => {
  return {
    ...initialState,
    setEmojiPickerTarget: (target) =>
      set(() => ({ emojiPickerTarget: target }), false, 'emojiPicker/setEmojiPickerTarget'),
  };
};
